import type { SearchDropdownItem } from '@/components/ui/search-dropdown'
import type { RentvineProperty } from '@super/shared-types'

export const mapPropertyToItem = (
  property: RentvineProperty,
): SearchDropdownItem<string> => ({
  id: property.propertyID,
  label: property.name || property.address,
  data: property.propertyID,
})
